
import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS
} from "./ActionType";
import { getUser } from "../../../User/State/Auth/Action";

const jwt = localStorage.getItem("jwt");

export const updateProfile = (profileId, profileData, setOpenModal) => async (dispatch) => {
  dispatch({ type: UPDATE_PROFILE_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/profile/${profileId}`,
      profileData
    );
    if (data.status === "SUCCESS") {
      dispatch(getUser(jwt))
      dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data });
      toast.success("Profile Updated !!");
      setOpenModal(false)
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PROFILE_FAILURE, payload: error.message });
  }
};
